import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-font-icon',
  template: `<em [className]="iconName" class="text-info mx-1"></em>`
})
export class FontIconComponent  {
  @Input() iconName: string;
}
